module.exports = __webpack_public_path__ + "img/load-empty-img2.eff6be93.png";